import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}
function cfg() { return { headers: getAuthHeaders(), timeout: 15000 }; }

export async function fetchCmdbHardware(codhar) {
  const base = getBase();
  if (!base || !codhar) return null;
  try {
    const res = await axios.get(base + '/cmdb/hardware/' + codhar, cfg());
    return res?.data ?? null;
  } catch (err) { return null; }
}
export async function fetchSistemasCmdb() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/cmdb/sistemas', cfg());
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}
export async function salvarGarantia(codhar, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/cmdb/hardware/' + codhar + '/garantia', body, cfg());
}
export async function adicionarLicenca(codhar, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/cmdb/hardware/' + codhar + '/licencas', body, cfg());
}
export async function removerLicenca(codhar, id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/cmdb/hardware/' + codhar + '/licencas/' + id, cfg());
}
export async function vincularSistema(codhar, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/cmdb/hardware/' + codhar + '/sistemas', body, cfg());
}
export async function desvincularSistema(codhar, id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/cmdb/hardware/' + codhar + '/sistemas/' + id, cfg());
}
